import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MyNetworkClientsResponse } from '@1po/1po-bff-fe-spec/generated/my_network/response/MyNetworkClientsResponse';
import { isDelegationSessionStatusLoading } from 'domains/delegation/DelegationSession.store';
import {
  fetchMyNetworkClientsRequestSaga,
  getMyNetworkClients,
  getMyNetworkClientsFilters,
  getMyNetworkClientsSort,
} from 'domains/r1Network/R1Network.store';
import { SearchData } from 'utils';

export const useFetchMyNetworkClients = (): SearchData<MyNetworkClientsResponse> => {
  const dispatch = useDispatch();
  const myNetworkClientsState = useSelector(getMyNetworkClients);
  const filters = useSelector(getMyNetworkClientsFilters);
  const sort = useSelector(getMyNetworkClientsSort);
  const isFirstRender = useRef(true);
  const isDelegationLoading = useSelector(isDelegationSessionStatusLoading);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      if (isDelegationLoading) {
        return;
      }
      dispatch(fetchMyNetworkClientsRequestSaga({}));
    } else {
      dispatch(fetchMyNetworkClientsRequestSaga({ page: 1 }));
    }
  }, [dispatch, filters, sort, isDelegationLoading]);

  return myNetworkClientsState;
};
